import Controller from "./cityCaptainApp.controller";
import template from "./cityCaptainApp.html";

const cityCaptainApp = {
  template,
  controller: Controller,
  bindings: {
    cityId: "<",
    selectedCaptainAppVersion: "<",
    selectedPingFrequency: "<",
    biddingCampaignsConfig: "<",
    backupShiftConfig: "<",
  },
};

export default cityCaptainApp;



// WEBPACK FOOTER //
// ./src/components/cityCaptainApp/cityCaptainApp.component.js